// extracted by mini-css-extract-plugin
module.exports = {"d2xDetailB":"B_d2xDetailB__4cdNs"};